import React, { useState, useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const shuffleArray = (array) => {
  const shuffledArray = [...array];
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }
  return shuffledArray;
};

// Data
const galleryData = [
  {
    id: 2,
    title: 'Life Groups Branding',
    thumbnail: '/images/life-groups-logo-small.jpg',
    images: ['/images/life-groups-logo-HIGH-RES.jpg'],
    mobileImage: '/images/mobile-life-groups-logo.jpg',
    description: 'Rittman Grace Brethren Church approached me for a new logo for their Small Groups program. Small groups are an important part of the growth of a church. That is why I thought it was important to incorporate the seedling in the design.',
    company: 'Rittman Grace Brethren Church, Rittman, OH',
  },
  {
    id: 3,
    title: 'EMS Providers',
    thumbnail: '/images/EM-Banners-small.jpg',
    images: ['/images/EM-Banners.jpg', '/images/Banner-1.jpg'],
    mobileImage: '/images/mobile-EM-Banners.jpg',
    description: 'These were large format outdoor banners that were created for EMS Week and EM Nurses Week. These banners were hung up outside the emergency rooms of 100+ hospitals across the country.',
    company: 'US Acute Care Solutions',
    link: '',
    buttonText: 'Explore Now',
  },
  {
    id: 5,
    title: '5th Annual Rubber City Classic',
    thumbnail: '/images/RCC-stack-small.jpg',
    images: ['/images/RCC-stack.jpg', '/images/RCC-poster.jpg', '/images/RCC-Book.jpg'],
    mobileImage: '',
    description: 'The Rubber City Classic is a disc golf tournament that takes place in Norton, OH every fall. I was presented with the opportunity to brand the tournament. This included the logo, any advertising, and the caddie book that was given to all players of the tournament.',
    company: 'Rubber City Classic Tournament',
    link: '',
    buttonText: 'See More',
  },
  {
    id: 6,
    title: 'Restaurant Menu',
    thumbnail: '/images/Carlos-menu-small.jpg',
    images: ['/images/Carlos-menu.jpg'],
    mobileImage: '',
    description: 'Need a description here.',
    company: 'Carlos Trattoria, Hartville, OH',
    link: '',
    buttonText: 'See Full Menu',
  },
  {
    id: 7,
    title: 'Rubber City Classic Caddy Book',
    images: ['/images/RCC-Book.jpg'],
    mobileImage: '',
    description: 'Need a description here.',
    company: 'Carlos Trattoria, Hartville, OH',
    link: 'https://example.com/4',
    buttonText: 'See Full Menu',
  },
  {
    id: 8,
    title: 'Restaurant Menu',
    images: ['/images/retain_banner.jpg'],
    mobileImage: '',
    description: 'Need a description here.',
    company: 'Carlos Trattoria, Hartville, OH',
    link: 'https://example.com/4',
    buttonText: 'See Full Menu',
  },
];

const Masonry = () => {
  const [shuffledGalleryData, setShuffledGalleryData] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  // Modal State
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    setShuffledGalleryData(shuffleArray(galleryData));
    setIsMobile(window.innerWidth < 768);

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Handle scroll lock when modal is open
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isModalOpen]);

  const openModal = (item) => {
    setModalData(item);
    setCurrentImageIndex(0);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) =>
      prev === modalData.images.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) =>
      prev === 0 ? modalData.images.length - 1 : prev - 1
    );
  };

  return (
    <div className="container mx-auto px-4 py-24">

      {/* Gallery Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {shuffledGalleryData.map((item) => (
          <div
            key={item.id}
            className="flex flex-col cursor-pointer group"
            onClick={() => openModal(item)}
          >
            {/* Image Wrapper */}
            <div className="rounded-lg overflow-hidden shadow-sm mb-3">
              <img
                src={
                  (isMobile && item.mobileImage)
                    ? item.mobileImage
                    : (item.thumbnail || item.images[0])
                }
                alt={item.title}
                className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
            </div>

            {/* ✅ Title Below - No Blue Hover */}
            <h3 className="text-lg font-bold text-gray-900">
              {item.title}
            </h3>
          </div>
        ))}
      </div>

      {/* Lightbox Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4 backdrop-blur-sm"
          onClick={closeModal}
        >
          <button
            className="absolute top-4 right-4 text-white/70 hover:text-white transition-colors z-[60]"
            onClick={closeModal}
          >
            <X className="w-10 h-10" />
          </button>

          <div
            className="bg-white max-w-6xl w-full h-[90vh] md:h-[80vh] rounded-lg shadow-2xl overflow-hidden flex flex-col md:flex-row"
            onClick={(e) => e.stopPropagation()}
          >

            {/* LEFT SIDE: Image Area */}
            <div className="w-full md:w-2/3 bg-black flex items-center justify-center relative h-1/2 md:h-full">
              <img
                src={modalData.images?.[currentImageIndex]}
                alt={modalData.title}
                className="max-h-full max-w-full object-contain"
              />

              {modalData.images && modalData.images.length > 1 && (
                <>
                  <button
                    onClick={prevImage}
                    className="absolute left-4 p-2 bg-white/10 hover:bg-white/30 rounded-full text-white transition-colors"
                  >
                    <ChevronLeft className="w-8 h-8" />
                  </button>
                  <button
                    onClick={nextImage}
                    className="absolute right-4 p-2 bg-white/10 hover:bg-white/30 rounded-full text-white transition-colors"
                  >
                    <ChevronRight className="w-8 h-8" />
                  </button>
                </>
              )}
            </div>

            {/* RIGHT SIDE: Information Panel */}
            <div className="w-full md:w-1/3 p-8 flex flex-col overflow-y-auto h-1/2 md:h-full bg-white text-left">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">{modalData.title}</h2>
              {modalData.company && (
                <p className="text-sm text-gray-500 italic mb-6 border-b pb-4">
                  {modalData.company}
                </p>
              )}
              <div className="prose text-gray-700 leading-relaxed mb-6">
                {modalData.description}
              </div>
              {modalData.link && (
                <div className="mt-auto pt-6">
                  <a
                    href={modalData.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block w-full text-center bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-md transition-colors"
                  >
                    {modalData.buttonText || 'View Project'}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Masonry;